<template>
	<div class="">
		<Header></Header>
		<van-row class="Aboutme">
			<van-row class="Aboutmebg">
				<img src="../assets/about/ysabout.png" alt="" height="300px">
			</van-row>
			<van-row class="AboutmeTit">
				<p class="col333">关于我们</p>
				<p class="col999">北京云师教育科技有限公司（简称云师）是一家互联网教育科技公司，专业提供互联网教育服务。公司旗下的云师教育平台是一个专注于教师服务的一站式平台，平台集合了教师考前培训、教师就业安置、教师岗前培训以及名师培养打造等一站式服务，致力于为教育行业输送优秀人才。云师认为，科技研发和教学研发是公司的核心竞争力，并已逐步建立起专业的IT技术团队和教学研发团队。云师努力为参培学员提供更高质量的教研成果、知识体系，同时为学员配合定制千人千面的个性化学习方案，从而使学员可以在短时间内提升学习效率，同时大幅度降低学习成本。</p>
			</van-row>
			<van-row class="Aboutmeline w95"></van-row>
			<van-row class="Aboutmelist">
				<p class="col333 col333f">云师使命</p>
				<p>教育报国，以优质人才回馈社会。</p>
			</van-row>
			<van-row class="Aboutmeline w95"></van-row>
			<van-row class="Aboutmelist">
				<p class="col333 col333f">云师愿景</p>
				<p>成为专为教师服务的一流互联网教育科技公司。</p>
			</van-row>
			<van-row class="Aboutmeline w95"></van-row>
			<van-row class="Sense w95">
				<p class="col333f">
					云师的价值观
				</p>
				<van-row class='Senseswiper'>
					<van-swipe :autoplay="5000" style='height: 200px;' indicator-color='#007CCF'>
						<van-swipe-item class='item1'>
							<p><img src="../assets/about/a1.png" alt=""></p>
							<p>客户、员工及一切合作伙伴共享未来</p>
						</van-swipe-item>
						<van-swipe-item class='item1'>
							<p><img src="../assets/about/a2.png" alt=""></p>
							<p>最好的服务就是把专业的知识教授给用户</p>
						</van-swipe-item>
						<van-swipe-item class='item1'>
							<p><img src="../assets/about/a3.png" alt=""></p>
							<p>协作、进取、担当是公司用人的重要标准</p>
						</van-swipe-item>
					</van-swipe>
				</van-row>
			</van-row>
			<van-row class="Aboutmeline w95"></van-row>
			<van-row class='list2 w95'>
				<p class="col333f">
					管理团队介绍
				</p>
				<van-row class='listbox'>
					<van-swipe style='height:360px;background: ;' indicator-color='#007CCF'>
						<van-swipe-item class='item1'>
							<div class="uesrcouent">
								<div class="userimg">
									<img src="../assets/about/a4.png" alt="">
								</div>
								<div class="username">
									<p>张 平</p>
									<p>ZHANGPING</p>
									<p> 教研副总裁</p>
									<p>北京大学研究生学历，从事培训行业10余年，曾长期在某上市培训机构担任教研教学负责人，具备较为扎实的专业知识功底，以及较为丰富的行业经验。</p>
								</div>
							</div>
						</van-swipe-item>
						<van-swipe-item class='item1'>
							<div class="uesrcouent">
								<div class="userimg">
									<img src="../assets/about/a5.png" alt="">
								</div>
								<div class="username">
									<p>余开义</p>
									<p>YUKAIYI</p>
									<p> 市场及渠道副总裁</p>
									<p>毕业于郑州航空工业管理大学，拥有12年教育行业经验及10年教育管理经验。曾担任北大青鸟线下运营负责人，08年于山东组建团队启动新校区。后担任山香教育全国运营中心负责人，在15年-17年间，极大程度地开拓了山香教育的规模，做到全国23个省份167家地市加盟校。拥有着极为丰富的线下运营经验。</p>
								</div>
							</div>
						</van-swipe-item>
						<van-swipe-item class='item1'>
							<div class="uesrcouent">
								<div class="userimg">
									<img src="../assets/about/a6.png" alt="">
								</div>
								<div class="username">
									<p>刘宝玺</p>
									<p>LIUBAOXI</p>
									<p> 技术副总裁(CTO)</p>
									<p>本科学历，从事互联网研发12年，具备6年互联网系统架构经验，某在线教育平台技术课程高级讲师。曾任某消费分期金融公司CTO，并带领50人的互联网技术团队，取得了丰硕的技术成果，拥有丰富的产品、技术研发及线上运营经验。</p>
								</div>
							</div>
						</van-swipe-item>
					</van-swipe>
				</van-row>
			</van-row>
		</van-row>
		<Fotter></Fotter>
	</div>
</template>
<script>
	import Header from "./Header.vue";
	import Fotter from "./Fotter.vue";
	export default {
		name: 'Aboutme',
		components: {
			Header,
			Fotter
		},
		data() {
			return {

			}

		},
		methods: {

		}
	}
</script>

<style scoped>
	.Aboutme {
		width: 100%;
		height: 100%;
	}

	.Aboutmebg {
		width: 100%;
		height: 300px;
		margin: 1px auto;
	}

	.Aboutmebg img {
		width: 100%;
		height: 100%;
	}

	.AboutmeTit p:nth-child(1) {
		text-align: center;
		font-size: 20px;
		font-weight: 600;
		line-height: 70px;
	}

	.AboutmeTit p:nth-child(2) {
		font-size: 14px;
		line-height: 20px;
		margin: 13px;
		font-size: 12px;
	}

	.Aboutmeline {
		height: 0px;
		border: 1px solid #72727712;
		margin: 5px auto;
	}

	.Aboutmelist p {
		margin: 13px;
		color: #666;
		font-size: 12px;
	}

	.Sense {
		margin: 20px auto;
	}

	.Sense .col333f {
		font-size: 20px;
		text-align: center;
	}

	.Senseswiper {
		width: 100%;
		height: 200px;
		overflow: hidden;

	}

	.Senseswiper .item1 p:nth-child(1) {
		width: 70px;
		height: 70px;
		background: #007CCF;
		border-radius: 100%;
		text-align: center;
		position: absolute;
		top: 27px;
		left: 0px;
		right: 0px;
		margin: auto;
	}

	.Senseswiper .item1 p:nth-child(1) img {
		width: 50px;
		height: 50px;
		border-radius: 100%;
		line-height: 70px;
		display: block;
		margin: 9px;
	}

	.Senseswiper .item1 p:nth-child(2) {
		font-size: 12px;
		font-weight: 400;
		line-height: 17px;
		color: rgba(102, 102, 102, 1);
		left: 0px;
		text-align: center;
		margin-top: 123px
	}

	.list2 {
		margin: 20px auto;
	}

	.list2 .col333f {
		font-size: 20px;
		text-align: center;
	}

	.listbox {
		margin: 60px auto 20px auto;
		width: 300px;
	}

	.listbox .userimg {
		width: 70px;
		height: 70px;
		background: #007CCF;
		border-radius: 100%;
		position: absolute;
		top: 6px;
		z-index: 9999;
		left: 116px;
	}

	.listbox .userimg img {
		width: 45px;
		height: 45px;
		margin: 12px;
	}

	.uesrcouent {
		position: relative;
	}

	.username {
		width: 100%;
		height: 500px;
		background: #fff;
		position: absolute;
		top: 54px;
		box-shadow: 0px 2px 5px rgba(0, 124, 216, 0.16);
	}

	.username p:nth-child(1) {
		font-size: 13px;
		line-height: 90px;
		color: rgba(51, 51, 51, 1);
		text-align: center;
		font-weight: bold;
	}

	.username p:nth-child(2) {
		font-size: 10px;
		text-align: center;
		font-weight: 300;
		margin-top: -20px;
		color: rgba(204, 204, 204, 1);
	}

	.username p:nth-child(3) {
		font-size: 12px;
		text-align: center;
		font-weight: 300;
		line-height: 17px;
		margin-top: 10px;
		color: rgba(51, 51, 51, 1);
	}

	.username p:nth-child(4) {
		font-size: 12px;
		font-weight: 300;
		line-height: 25px;
		color: rgba(102, 102, 102, 1);
		margin: 13px 0px 30px 13px;
	}
</style>



// WEBPACK FOOTER //
// src/components/Aboutme.vue